module.exports = __webpack_public_path__ + "mobile-faq-header-img.e979216d.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Faq/mobile-faq-header-img.jpg
// module id = 615
// module chunks = 0